<template>
  <div>
    <h2 class="page-header">
      Unit Measure
    </h2>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-lg-6 col-md-6">
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label"> UOM Name KH</label>
              <div class="col-md-7">
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('uom_name_kh') }"
                  v-model="model.uom_name_kh"
                  placeholder="UOM name Kh"
                />
                <div class="invalid-feedback" v-if="errors.has('uom_name_kh')">
                  {{ errors.first('uom_name_kh') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                UOM Name EN <span class="text-danger">*</span></label
              >
              <div class="col-md-7">
                <input
                  v-model="model.uom_name_en"
                  type="text"
                  class="form-control kh-font"
                  :class="{ 'is-invalid': errors.has('uom_name_en') }"
                  placeholder="UOM name En"
                />
                <div class="invalid-feedback" v-if="errors.has('uom_name_en')">
                  {{ errors.first('uom_name_en') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                Quantity
              </label>
              <div class="col-md-7">
                <input type="number" class="form-control" v-model.number="model.uom_qty" placeholder="UOM QTY" />
                <div class="invalid-feedback" v-if="errors.has('uom_qty')">
                  {{ errors.first('uom_qty') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label"></label>
              <div class="col-sm-7">
                <div class="checkbox checkbox-css">
                  <input type="checkbox" id="cssCheckbox1" v-model="model.is_default" />
                  <label for="cssCheckbox1"> Default</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="row  text-right">
          <div class="col-lg-12">
            <ts-button color="primary" :waiting="save_add_new" @click="onSaveAddNew">
              Save Add New
            </ts-button>
            <ts-button class="ml-2" color="primary" :waiting="saving" @click="onSave">
              Save
            </ts-button>

            <ts-button class="ml-2" @click="$router.push({ name: 'unit-measure' })">
              Cancel
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'measure-create',

  data() {
    return {
      model: {
        uom_name_kh: '',
        uom_name_en: '',
        uom_qty: '',
        is_default: false
      },
      errors: new Errors(),
      saving: false,
      save_add_new: false
    }
  },
  methods: {
    onSave() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('inventory/unitMeasure/store', Object.assign({}, this.model))
        .then(response => {
          this.saving = false
          this.clearForm()
          this.$toasted.success(response.message)
          this.$router.push({ name: 'unit-measure' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.saving = false
          this.$toasted.error(error.message)
        })
    },
    onSaveAddNew() {
      this.errors = new Errors()
      this.save_add_new = true
      this.$store
        .dispatch('inventory/unitMeasure/store', Object.assign({}, this.model))
        .then(response => {
          this.save_add_new = false
          this.clearForm()
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.save_add_new = false
          this.$toasted.error(error.message)
        })
    },

    clearForm() {
      this.model.uom_name_kh = ''
      this.model.uom_name_en = ''
      this.model.uom_qty = ''
      this.model.is_default = false
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('inventory/unitMeasure/RESET_STATE')
    }
    next()
  }
}
</script>
